module.exports = __webpack_public_path__ + "img/time.4c456783.svg";